import axios from 'axios';
import { handleInvalidToken } from '../../utils/Auth';
import { getAuthToken } from './getAuthHeaders';

export default function setupAxiosConfig() {
  // set auth globally
  axios.defaults.headers.common['Authorization'] = getAuthToken();

  // Instead of trying to refresh the token with the interceptor,
  // we will simply fetch the latest token form the storage and let
  // the apps timer handle the token refresh at the appropriate time
  axios.interceptors.request.use(async (req) => {
    // get latest token
    const latestToken = getAuthToken();
    if (latestToken) {
      req.headers.Authorization = latestToken;
    }
    return req;
  });

  // handle response error globally
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      handleInvalidToken(error, true);
      return Promise.reject(error);
    }
  );
}
